import {
  LocationQueryValue,
  RouteParamsGeneric,
  RouteRecordNameGeneric,
} from 'vue-router'

export interface QueryParamAction {
  priority: number
  to: {
    query?: internalQueryParams
    name?: RouteRecordNameGeneric
    params?: RouteParamsGeneric
  }
}

export enum QueryParamRedirect {
  ORDERS = 'orders',
}

export enum ThemeQueryParamBoolean {
  TRUE = 'true',
  FALSE = 'false',
}

export enum ThemeQueryParams {
  ML_CT_COLOR_PRIMARY = 'ml_ct_color_primary',
  ML_CT_COLOR_ACCENT = 'ml_ct_color_accent',
  ML_CT_COLOR_BODY = 'ml_ct_color_body',
  ML_CT_DARK_MODE = 'ml_ct_dark_mode',
  ML_CT_HIGH_CONTRAST_MODE = 'ml_ct_high_contrast_mode',
}

export type ThemeQueryParamsValue = {
  [ThemeQueryParams.ML_CT_COLOR_PRIMARY]: string
  [ThemeQueryParams.ML_CT_COLOR_ACCENT]: string
  [ThemeQueryParams.ML_CT_COLOR_BODY]: string
  [ThemeQueryParams.ML_CT_DARK_MODE]: ThemeQueryParamBoolean
  [ThemeQueryParams.ML_CT_HIGH_CONTRAST_MODE]: ThemeQueryParamBoolean
}

export enum QueryParams {
  REDIRECT = 'ml_app_redirect',
  PREFERRED_PLACEMENTS = 'ml_app_preferred_placements',
  TEST_MODE_TOKEN = 'ml_app_test_mode_token',
}

export enum PartialQueryParams {
  ML_METADATA = 'ml_metadata_',
}

export type QueryParamValue = {
  [QueryParams.REDIRECT]: QueryParamRedirect
  [QueryParams.PREFERRED_PLACEMENTS]: string
  [QueryParams.TEST_MODE_TOKEN]: string
  [PartialQueryParams.ML_METADATA]: unknown
}

export type QueryEntry<K extends QueryParams = QueryParams> = [
  K,
  QueryParamValue[K],
]

export type internalQueryParams = {
  [p: string]: string | null | LocationQueryValue[] | undefined
}
